import React from 'react';

import { PropTypes } from 'prop-types';

const SearchMeta = ({ returned, totalEntries, loading }) => {
  if (!loading) {
    return (
      <p>
        Showing {returned} of {totalEntries}
      </p>
    );
  } else {
    return (
      <p>
        Loading...
      </p>
    );
  }
};

SearchMeta.propTypes = {
  returned:     PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  totalEntries: PropTypes.number,
  loading:      PropTypes.bool
};

export default SearchMeta;
